import React from "react";

export const ArtifactDeleteBody = ({ artifact }) => {
    if (!artifact) return null;

    return (
        <>
            <p className="modal-msg-title text-danger">Do you want to delete:</p>

            <div className="mt-2">
                <strong>
                    {artifact.artifactName} - {artifact.version}
                </strong>
            </div>
        </>
    );
};
